export const FollowCallQuestionnaire = {
  APPOINTMENT: {
    ANSWERER: {
      text: 'ご回答されるお客様情報',
      NAME: { text: '名前' },
      EMAIL: { text: 'メールアドレス' },
    },
    OPERATOR_FEEDBACK: {
      text: 'フォローコールのオペレーターについて',
      GOOD: {
        text: 'フォローコールオペレーターについて良かった点を選択してください。',
        options: [
          { value: 1, text: '迅速な対応' },
          { value: 2, text: '丁寧な対応' },
          { value: 3, text: '有益な情報提供' },
          { value: 4, text: '特になし' },
          { value: 5, text: 'その他' },
        ],
      },
      IMPROVING: {
        text: 'フォローコールオペレーターについて改善が必要だと感じた点を選択してください。',
        options: [
          { value: 1, text: '対応時間が長い' },
          { value: 2, text: '対応が不適切' },
          { value: 3, text: '情報提供が不足' },
          { value: 4, text: '特になし' },
          { value: 5, text: 'その他' },
        ],
      },
    },
    APPOINTMENT_FEEDBACK: {
      text: '商談の質について',
      TARGET_SELECT: {
        text: '商談のターゲットの選定について',
        options: [
          { value: 1, text: '非常に適切' },
          { value: 2, text: '適切' },
          { value: 3, text: 'どちらとも言えない' },
          { value: 4, text: '不適切' },
          { value: 5, text: '非常に不適切' },
        ],
      },
      TARGET_SELECT_DETAIL: {
        text: '上記の理由をお聞かせください。',
      },
      TARGET_INTEREST_LEVEL: {
        text: '商談相手の関心度について',
        options: [
          { value: 1, text: '非常に高い' },
          { value: 2, text: '高い' },
          { value: 3, text: 'どちらとも言えない' },
          { value: 4, text: '低い' },
          { value: 5, text: '非常に低い' },
        ],
      },
      TARGET_INTEREST_LEVEL_DETAIL: {
        text: '上記の理由をお聞かせください。',
      },
      IMPROVING_QUALITY: {
        text: '商談の質向上のために改善が必要だと感じた点を選択してください。',
        options: [
          { value: 1, text: 'より詳細なターゲット選定' },
          { value: 2, text: 'より詳細な情報提供' },
          { value: 3, text: 'カスタマイズされた提案の提供' },
          { value: 4, text: '特になし' },
          { value: 5, text: 'その他' },
        ],
      },
    },
    OTHER: {
      text: 'その他',
      OPINION: [
        {
          text: '上記の点以外で、ご意見・ご質問などありましたらご記入ください。',
        },
      ],
    },
  }
};


// WEBPACK FOOTER //
// ./src/constants/Questionnaire.js